import { useState } from "react";

interface FilterBarProps {
  tagOptions: string[];
  attrOptions: string[];
  cvOptions: string[];
  selectedTag: string;
  selectedAttr: string;
  selectedCv: string;
  onlyNew: boolean;
  onSelectTag: (v: string) => void;
  onSelectAttr: (v: string) => void;
  onSelectCv: (v: string) => void;
  onToggleNew: () => void;
  onReset: () => void;
}

function ChipRow({
  label,
  options,
  selected,
  onSelect
}: {
  label: string;
  options: string[];
  selected: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-3 last:border-b-0 md:flex-row md:items-start md:gap-4">
      <span className="shrink-0 pt-1 text-sm font-medium text-foreground-700 md:w-16">{label}</span>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onSelect("")}
          className={`rounded-full border px-3 py-1 text-xs transition-colors cursor-pointer ${
            selected === ""
              ? "border-primary-300 bg-primary-100 text-primary-700"
              : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-200"
          }`}
        >
          全部
        </button>
        {options.map((opt) => (
          <button
            key={opt}
            onClick={() => onSelect(opt === selected ? "" : opt)}
            className={`rounded-full border px-3 py-1 text-xs transition-colors cursor-pointer ${
              selected === opt
                ? "border-primary-300 bg-primary-100 text-primary-700"
                : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-200"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  tagOptions,
  attrOptions,
  cvOptions,
  selectedTag,
  selectedAttr,
  selectedCv,
  onlyNew,
  onSelectTag,
  onSelectAttr,
  onSelectCv,
  onToggleNew,
  onReset
}: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between px-4 py-3 md:hidden">
        <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </span>
        <button
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-1 text-sm text-primary-600 cursor-pointer"
        >
          {open ? "收起" : "展开"}
          <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
        </button>
      </div>

      <div className={`${open ? "block" : "hidden"} px-4 pb-3 md:block md:p-4`}>
        <ChipRow label="类型" options={tagOptions} selected={selectedTag} onSelect={onSelectTag} />
        <ChipRow label="属性" options={attrOptions} selected={selectedAttr} onSelect={onSelectAttr} />
        <ChipRow label="声优" options={cvOptions} selected={selectedCv} onSelect={onSelectCv} />

        <div className="flex flex-col gap-2 border-b border-background-200 py-3 md:flex-row md:items-center md:gap-4">
          <span className="shrink-0 text-sm font-medium text-foreground-700 md:w-16">新角色</span>
          <div className="flex flex-wrap items-center gap-2">
            <button
              onClick={() => onlyNew && onToggleNew()}
              className={`rounded-full border px-3 py-1 text-xs transition-colors cursor-pointer ${
                !onlyNew
                  ? "border-primary-300 bg-primary-100 text-primary-700"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-200"
              }`}
            >
              全部角色
            </button>
            <button
              onClick={() => !onlyNew && onToggleNew()}
              className={`rounded-full border px-3 py-1 text-xs transition-colors cursor-pointer ${
                onlyNew
                  ? "border-accent-300 bg-accent-100 text-accent-800"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-accent-200"
              }`}
            >
              仅看新角色
            </button>
          </div>
        </div>

        <div className="flex justify-end pt-3">
          <button
            onClick={onReset}
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-refresh-line"></i>
            重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}